import { render, staticRenderFns } from "./overviewRatioReadBox.vue?vue&type=template&id=50d6cc82&"
import script from "./overviewRatioReadBox.vue?vue&type=script&lang=ts&"
export * from "./overviewRatioReadBox.vue?vue&type=script&lang=ts&"
import style0 from "./overviewRatioReadBox.vue?vue&type=style&index=0&id=50d6cc82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports